"use client";

import { useEffect } from "react";

/**
 * Client component that scrolls to top on mount.
 * Wrap page content with this to ensure scroll resets.
 */
export default function ScrollToTop({ children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return children;
}
